import React, { createContext, useContext, useState, useEffect } from "react";

const VerifierContext = createContext(null);
const API_BASE = process.env.REACT_APP_BACKEND_URL + "/api";

async function verifierFetch(path, options = {}) {
  const token = localStorage.getItem("verifier_token");
  const res = await fetch(`${API_BASE}${path}`, {
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...options,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: "Request failed" }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
  return res.json();
}

export const VerifierProvider = ({ children }) => {
  const [verifierUser, setVerifierUser] = useState(null);
  const [loading,      setLoading]      = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("verifier_token");
    const user  = localStorage.getItem("verifier_user");
    if (token && user) {
      try { setVerifierUser(JSON.parse(user)); } catch {}
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const data = await verifierFetch("/verifier/auth/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });
    localStorage.setItem("verifier_token", data.token);
    localStorage.setItem("verifier_user", JSON.stringify(data.user));
    setVerifierUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("verifier_token");
    localStorage.removeItem("verifier_user");
    setVerifierUser(null);
  };

  return (
    <VerifierContext.Provider value={{ verifierUser, loading, login, logout, verifierFetch }}>
      {children}
    </VerifierContext.Provider>
  );
};

export const useVerifier = () => {
  const ctx = useContext(VerifierContext);
  if (!ctx) throw new Error("useVerifier must be used within VerifierProvider");
  return ctx;
};
